import ExpensesService from "../services/expenses.service";

const state = {
	expensesList: [],
	deleteStatus: '',
	itemLocalStore: {},
	totalExpenses: 0,
}
const getters = {}
const actions = {

	async createExpenses({commit}, data) {
		try {
			const createExpensesRes = await ExpensesService.saveExpensesService(data);
			commit('setCreateRes', createExpensesRes.data);
			return true;
		} catch (e) {
			return false;
		}
	},
	async getAllExpensesStore({commit}, searchForm) {
		try {
			const listRes = await ExpensesService.getAllExpenses(searchForm);
			commit('setListExpenses', listRes);
			return true;
		} catch (e) {
			return false;
		}
	},
	async deleteExpensesStore({commit}, id) {
		try {
			const deleteRes = await ExpensesService.deleteExpenses(id);
			commit('deleteRes', deleteRes);
			return true;
		} catch (e) {
			return false;
		}
	},
	async getExpensesById({commit}, id) {
		try {
			const getByIdRes = await ExpensesService.getByIdExpensesService(id);
			commit('setByIdExpenses', getByIdRes);
			return true
		} catch (e) {
			return false
		}
	},
	async updateExpensesStore({commit}, data) {
		try {
			const updateRes = await ExpensesService.updateExpenses(data);
			commit('setUpdateRes', updateRes);
			return true;
		} catch (e) {
			return false;
		}
	},
	async searchFilter({commit},data) {
		try {
			const searchFilter = await ExpensesService.searchFilterService(data);
			commit('setSearchRes', searchFilter);
			return true;
		} catch (e) {
			return false;
		}
	}


}
const mutations = {
	setSearchRes(state, res) {
		state.expensesList = res.data.items;
		state.totalExpenses = res.data.total;
	},
	setUpdateRes(state, res) {

	},
	setByIdExpenses(state, res) {
		state.itemLocalStore = res.data;
	},
	deleteRes(state, res) {
		state.deleteStatus = res;
	},
	setCreateRes(state, resCreate) {
	},
	setListExpenses(state, res) {
		state.expensesList = res.data.items;
		state.totalExpenses = res.data.total;

	}
}
export const expenses = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
